import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';

export default function BackLink(props) {
    const {t} = useTranslation();
    return (
        <div><Link to={`/${props.to ?? ''}`}>{t('links.goBack')}</Link></div>
    )
}